import axios from '@/util/request';
// import Qs from 'qs'
export function getCompanyInfo(parameter) {
  //公司管理-公司列表
  return axios({
    url: '/admin/dept/getDeptInfo',
    method: 'get',
    params: parameter
  })
}

export function addCompany(parameter) {
  //公司管理-新增公司
  return axios({
    url: '/admin/dept',
    method: 'post',
    data: parameter,
  })
}

export function updateCompany(parameter) {
  //公司管理-更新公司信息
  return axios({
    url: '/admin/dept',
    method: 'put',
    data: parameter,
  })
}
export function enableDept(parameter) {
  //公司管理-更新公司信息2
  return axios({
    url: `/admin/dept/enableDept?deptId=${parameter}`,
    method: 'put',
  })
}
export function delCompany(id) {
  //公司管理-删除公司
  return axios({
    url: '/admin/dept/' + id,
    method: 'DELETE'
  })
}

export function uploadLogo(logoPath) {
  //公司管理-上传logo
  return axios({
    url: '/admin/dept/uploadLogo',
    method: 'get',
    params: logoPath
  })
}


// WEBPACK FOOTER //
// ./src/api/systemApi.js